<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<div class="privacy-section">
    <div class="container">
        <div class="legal-content">
            <h1>{{ 'PRIVACY.TITLE' | translate }}</h1>
            <div class="last-updated">
                {{ 'PRIVACY.LAST_UPDATED' | translate }}: {{ '2024-03-20' | date:'longDate' }}
            </div>

            <section>
                <!-- Gazda site-ului web -->
                <h3>{{ 'PRIVACY.WEBSITE_HOST.TITLE' | translate }}</h3>
                <p>propero.io</p>
                <p>Brașov</p>
                <p>România</p>

                <!-- Management -->
                <!-- <h3>{{ 'PRIVACY.MANAGEMENT.TITLE' | translate }}</h3>
                <p>-</p> -->

                <!-- Informații de contact -->
                <!-- <h3>{{ 'PRIVACY.CONTACT_INFORMATION.TITLE' | translate }}</h3>
                <p>Contact</p> -->

                <!-- Înregistrarea companiei -->
                <!-- <h3>{{ 'PRIVACY.COMPANY_REGISTRATION.TITLE' | translate }}</h3>
                <p>{{ 'PRIVACY.COMPANY_REGISTRATION.CONTENT' | translate }}</p> -->

                <!-- Număr de înregistrare TVA -->
                <!-- <h3>{{ 'PRIVACY.VAT_NUMBER.TITLE' | translate }}</h3>
                <p>{{ 'PRIVACY.VAT_NUMBER.CONTENT' | translate }}</p> -->

                <!-- Declinare responsabilitate -->
                <h3>{{ 'PRIVACY.NOTES.TITLE' | translate }}</h3>
                <p>{{ 'PRIVACY.NOTES.CONTENT_1' | translate }}</p>
                <p>{{ 'PRIVACY.NOTES.CONTENT_2' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.CONTACT.DESCRIPTION' | translate }}</p>
                <div class="contact-info">
                    <p><strong>{{ 'CONTACT.DATA.EMAIL_CONTACT.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.EMAIL_CONTACT.VALUE' | translate: translationParams }}</p>
                    <p><strong>{{ 'CONTACT.DATA.PHONE.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.PHONE.VALUE' | translate: translationParams }}</p>
                    <p><strong>{{ 'CONTACT.DATA.ADDRESS.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.ADDRESS.VALUE' | translate: translationParams }} </p>
                </div>
            </section>
        </div>
    </div>
</div>